import * as $swal from "sweetalert2";

const axios = require('axios');
const cookie_setting = "stg-sven-tdh";
const storage_path = "qti-store-tdh";
let moment = require('moment-jalaali')

const base_url = 'https://api.mindandlove1.com/'

let oracle = {
    isMobile() {
        let flag = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
            navigator.userAgent
        );
        return flag || screen.width <= 760;
    },
    MillitoDate(date) {
        return moment(date).format('jYYYY-jMM-jDD HH:mm')
    },
    encode(object) {
        if (object == null) {
            return null;
        }
        return encodeURIComponent(JSON.stringify(object));
    },
    decode(object) {
        if (object == null) {
            return null;
        }
        return JSON.parse(decodeURIComponent(object));
    },
    setToken(request) {
        this.setData(storage_path, request, true);
    },
    getToken() {
        return this.getData(storage_path, true);
    },
    getData(key, secure) {
        let token = localStorage.getItem(key);
        if (token != null && token.length > 0) {
            if (!secure) {
                return JSON.parse(decodeURIComponent(token));
            } else {
                return atob(token);
            }
        }
        let name = key + "=";
        let data = document.cookie.split(";");
        for (let i = 0; i < data.length; i++) {
            let c = data[i];
            while (c.charAt(0) === " ") {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                if (!secure) {
                    return JSON.parse(decodeURIComponent(c.substring(name.length, c.length)));
                } else {
                    return atob(c.substring(name.length, c.length));
                }
            }
        }
        return null;
    },
    setData(key, value, secure) {
        let data = "";
        if (value != null) {
            if (secure != null && secure) {
                data = btoa(value)
            } else {
                data = encodeURIComponent(JSON.stringify(value))
            }
        }
        localStorage.setItem(key, data);
        if (!secure) {
            return;
        }
        let date = new Date();
        date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();
        document.cookie = key + "=" + data + ";" + expires + ";path=/";
    },
    logOut() {
        let date = new Date();
        date.setTime(date.getTime() - 100 * 24 * 60 * 60 * 1000);
        let expires = "expires=" + date.toUTCString();
        document.cookie = storage_path + "=;" + expires + ";path=/";
        localStorage.removeItem(cookie_setting);
        localStorage.removeItem(storage_path);
        window.location.href = "/register";
    },
    axios(url, data, onSuccess, onError, onProgress, extra) {
        axios({
            method: 'post',
            url: base_url + url,
            headers: {
                'Authorization': this.getToken(),
                'Content-Type': 'application/json;charset=UTF-8'
            },
            data: data,
            timeout: 30000,
            onDownloadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent)
                }
            },
        }).then(function (response) {
            if (response != null && response.data != null && response.data.success != null && response.data.success == true) {
                if (response.headers != null && response.headers['authorization'] != null) {
                    oracle.setToken(response.headers['authorization'])
                } else if (response.headers != null && response.headers['Authorization'] != null) {
                    oracle.setToken(response.headers['Authorization'])
                }
                if (onSuccess != null) {
                    if (extra != null) {
                        onSuccess(response.data, extra);
                    } else {
                        onSuccess(response.data);
                    }
                }
            } else {
                handleError(response != null ? response : null, onError)
            }
        }).catch(function (error) {
            handleError(error != null && error.response != null ? error.response : null, onError)
        });
    },
    axiosUpload(data, onSuccess, onError, onProgress, customName) {
        let formData = new FormData()
        if (customName != null) {
            formData.append("file", data, customName)
        } else {
            formData.append("file", data)
        }
        axios({
            method: 'post',
            url: base_url + "file/upload",
            data: formData,
            headers: {
                'Authorization': this.getToken(),
                'Content-Type': 'multipart/form-data'
            },
            timeout: 120000,
            onDownloadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent)
                }
            },
            onUploadProgress: function (progressEvent) {
                if (onProgress != null) {
                    onProgress(progressEvent);
                }
            }
        }).then(function (response) {
            if (response != null && response.data != null && response.data.success != null && response.data.success == true) {
                if (onSuccess != null) {
                    onSuccess(response.data)
                }
            } else {
                handleError(response != null ? response : null, onError)
            }
        }).catch(function (error) {
            handleError(error != null && error.response != null ? error.response : null, onError)
        });
    }
}

function handleError(param, onError) {
    if (param != null && param.data != null) {
        param = param.data
    }
    if (onError != null) {
        onError(param)
    }
    if (param != null && param.status != null && param.status == 401) {
        oracle.logOut()
        return
    }
    if (param != null && param.message != null) {
        $swal.fire({
            html: '<p>' + param.message + '</p>',
            // icon: 'error',
            showCloseButton: true,
            showConfirmButton: false,
            imageUrl: require("@/assets/image/lg23.png"),
            imageSize: '180x180', // add your dynamic height and width here
            imageWidth: 70,
            imageHeight: 70,
            customClass: {
                popup: 'format'
            }
        })
    }
}

export default oracle
export const dev_mode = true
export const globals = {}
